import React from "react";
import { joinClasses } from "../../utils/textUtils";

interface Props {
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  h6?: boolean;
  hero?: boolean;
  className?: string;
  children: any;
  id?: string;
}

export default function Heading(props: Props) {
  const { h1, h2, h3, h4, h5, h6, hero, className, children, id } = props;
  const headingClass = joinClasses([className, hero && "hero"]);
  let size = 1;

  if (h1) size = 1;
  if (h2) size = 2;
  if (h3) size = 3;
  if (h4) size = 4;
  if (h5) size = 5;
  if (h6) size = 6;

  switch (size) {
    case 1:
      return (
        <h1 className={headingClass} id={id}>
          {children}
        </h1>
      );
    case 2:
      return (
        <h2 className={headingClass} id={id}>
          {children}
        </h2>
      );
    case 3:
      return (
        <h3 className={headingClass} id={id}>
          {children}
        </h3>
      );
    case 4:
      return (
        <h4 className={headingClass} id={id}>
          {children}
        </h4>
      );
    case 5:
      return (
        <h5 className={headingClass} id={id}>
          {children}
        </h5>
      );
    case 6:
      return (
        <h6 className={headingClass} id={id}>
          {children}
        </h6>
      );

    default:
      return (
        <h1 className={headingClass} id={id}>
          {children}
        </h1>
      );
  }
}
